<template>
  <div class="app-container">
    <div class="app-container-header">
      <div class="app-container-header_main">
        <div style="float: left">
          <span>试卷总分：{{ form.passLine }}/{{ getAllPonit }}</span>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <span>试卷题目数：{{ finishNum }}/{{ tableData.length }}</span>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <span>时间：{{ form.minuteLimit }}</span>
        </div>
        <div style="float: right">
          <el-button type="text" size="small" @click="bandleStart" v-if="disableds">开始考试</el-button>
          <el-button type="text" size="small" @click="bandleSubmit" v-else>提交试卷</el-button>
        </div>
      </div>
    </div>
    <div class="app-container-body">
      <div class="ul">
        <div class="li">
          <div class="pater_title">{{ form.title }}</div>
          <div class="pater_desc">{{ form.desc }}</div>
        </div>
        <div class="li" v-for="(item, index) in tableData" :key="index">
          <div class="title_question_all">
            <div class="topic_question">{{ index + 1 }}.</div>
            <div class="title_question">
              <span>{{ item.title }}</span>
            </div>
          </div>
          <div class="table_par">
            <div class="table_radio_question" v-if="item.type == 0 || item.type == 2">
              <div class="radio" v-for="(item2, index2) in item.options" :key="index2">
                <el-radio v-model="item.answer" :label="item2.option" :disabled="disableds">
                  {{ item2.option }}
                </el-radio>
              </div>
            </div>
            <div class="table_checkBox_question" v-else-if="item.type == 1">
              <el-checkbox-group v-model="item.answer" :disabled="disableds">
                <el-checkbox v-for="(item2, index2) in item.options" :key="index2" :label="item2.option">
                  {{ item2.option }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="table_textarea_question" v-else-if="item.type == 3">
              <el-input type="text" v-model="item.answer" :disabled="disableds" />
            </div>
            <div class="table_textarea_question" v-else-if="item.type == 4">
              <el-input
                type="textarea"
                :rows="5"
                v-model="item.answer"
                placeholder=""
                :maxlength="-1"
                :show-word-limit="false"
                :autosize="{ minRows: 2, maxRows: 6 }"
                :disabled="disableds"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPager, answersheetAnswer, answersheetRetest, upAnswersheetAnswer } from '@/api/pager';
import { removeWatermark, setWaterMark } from '@/utils/watermark';

export default {
  name: 'ExamPager',
  data() {
    return {
      form: {},
      tableData: [],
      minute: 0,
      finishNum: 0,
      disableds: true,
      Time: null,
    };
  },
  computed: {
    getAllPonit() {
      let total = 0;
      this.tableData.forEach(ele => (total += ele.point));
      return total;
    },
  },
  watch: {
    tableData: {
      handler(newVal) {
        this.finishNum = 0;
        newVal.forEach(ele => {
          if (ele.type == 1 && ele.answer.length != 0) {
            this.finishNum += 1;
          } else if (ele.type != 1 && ele.answer != null) {
            this.finishNum += 1;
          }
        });
      },
      deep: true,
    },
  },

  mounted() {
    const { userName, userRealName } = this.$store.state.userInfo;
    setWaterMark(userName, userRealName);
  },
  destroyed() {
    removeWatermark();
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      const { params } = this.$route;
      const res = await getPager(params.id);
      if (res.code == 0) {
        this.form = res.data;
        this.minute = Number(res.data.minuteLimit) * 60;
        this.form.minuteLimit = this.$moment.utc(Number(res.data.minuteLimit) * 60 * 1000).format('HH:mm:ss');
        this.tableData = res.data.questions;
        this.tableData.forEach(item => {
          if (item.type == 1) {
            item.answer = [];
          }
        });
        this.$nextTick(() => {
          if (params.type == 1) {
            this.bandleStart();
          }
        });
      }
    },
    async bandleStart() {
      const { params } = this.$route;
      const res = await answersheetAnswer({ paperId: params.id });
      if (res.code == 0) {
        this.disableds = false;

        if (res.data != null) {
          this.minute = res.data;
        }
        this.$message.success('考试已开始，请及时作答。')
        this.setInterval();
      } else if (res.code == 1 && res.msg == '已超过答题时间,请重考') {
        if (res.data != null) {
          this.minute = res.data;
        }
        this.$confirm('是否重考?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          closeOnPressEscape: false,
          closeOnClickModal: false,
        })
          .then(async () => {
            const res = await answersheetRetest(params.id);
            if (res.code == 0) {
              this.disableds = false;

              this.setInterval();
            }
          })
          .catch(() => {
            this.$router.replace('/pager');
          });
      } else if (res.code == 1 && res.msg == '已超过答题时间且无重考机会') {
        this.$confirm(res.msg, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          closeOnPressEscape: false,
          closeOnClickModal: false,
        })
          .then(() => {
            this.$route.replace('/pager');
          })
          .catch(() => {
            this.$router.replace('/pager');
          });
      }
    },
    async bandleSubmit() {
      // if (this.finishNum != this.tableData.length) return this.$message.error('题目未答完，请继续作答。');
      const { params } = this.$route;
      let form = {
        paperId: params.id,
        answers: this.tableData.map(item => {
          return {
            questionId: item.id,
            answer: item.type == 1 ? item.answer.join(',') : item.answer,
          };
        }),
      };

      try {
        const res = await upAnswersheetAnswer(form);
        if (res.code == 0) {
          const text = res.data == null ? '确定' : res.data ? '确定' : '重新考试';

          this.$confirm(res.msg, '提示', {
            confirmButtonText: text,
            cancelButtonText: '取消',
            type: 'warning',
            showClose: false,
            closeOnPressEscape: false,
            closeOnClickModal: false,
          })
            .then(() => {
              this.tableData.forEach(item => {
                if (item.type == 1) {
                  item.answer = [];
                } else {
                  item.answer = null;
                }
              });

              if (text == '确定') {
                this.$router.replace('/');
              } else {
                this.bandleStart();
              }
            })
            .catch(() => {
              this.$router.replace('/');
            });
        }
      } finally {
        clearInterval(this.Time);
      }
    },
    setInterval() {
      if (this.Time) {
        clearInterval(this.Time);
      }

      this.Time = setInterval(() => {
        this.minute -= 1;
        if (this.minute == 5) {
          this.$message.info('考试还剩 5 分钟，超时将自动提交。');
        }
        if (this.minute == 0) {
          this.bandleSubmit();
        }
        this.form.minuteLimit = this.$moment.utc(Number(this.minute) * 1000).format('HH:mm:ss');
        if (this.minute == 0) {
          clearInterval(this.Time);
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  background: rgb(245, 245, 245);
  height: 100%;
}

.app-container-header {
  position: relative;
  z-index: 102;
  width: 100%;
  height: 42px;
  background: #313131;
  box-shadow: 0px 1px 0px 0px rgb(191 191 191);

  .app-container-header_main {
    width: 1110px;
    color: #fff;
    margin: 0 auto;
    line-height: 42px;
    font-size: 14px;
  }
}

.app-container-body {
  height: calc(100% - 42px);
  overflow-y: scroll;
  padding: 10px 0;
  .ul {
    min-height: 100%;
    width: 800px;
    margin: 0 auto;
    background-color: #fff;
    .boder-bootom {
      border-bottom: 1px solid #e0e0e0 !important;
    }
    .li {
      padding: 20px 50px;

      .pater_title {
        font-size: 24px !important;
        font-weight: bold;
        color: #000;
        vertical-align: middle;
        margin: 0;
        padding: 15px 0;
        line-height: 30px;
        text-align: center;
      }

      .pater_desc {
        text-align: center;
        color: #333333;
      }

      .title_question_all {
        font-size: 17px;
        margin-bottom: 6px;
        color: #444444;
        font-weight: bold;
        height: auto;
        line-height: 20px;
        position: relative;

        &::after {
          content: '';
          clear: both;
          display: block;
        }
        .topic_question {
          position: static;
          width: 28px;
          float: left;
          text-align: left;
          text-indent: 0;
        }

        .title_question {
          float: left;

          .req {
            color: red;
            font-weight: bold;
            position: absolute;
            top: 3px;
            left: -10px;
          }

          .qtypetip {
            color: #999;
            font-weight: normal;
            font-size: 14px;
          }
        }
      }

      .table_par {
        .table_radio_question {
          .radio {
            padding: 5px;
          }
        }

        .table_checkBox_question {
          .el-checkbox-group {
            width: max-content;
            .el-checkbox {
              display: block;
              padding: 5px;
            }
          }
        }
      }
    }
  }
}

.el-input ::v-deep .el-input__inner {
  border-radius: 0;
}

.el-textarea ::v-deep .el-textarea__inner {
  border-radius: 0;
  font-family: 'element-icons';
}
</style>
